<template>
  <!-- FAQ组件，高度问题还未解决 -->
  <div class="container">
    <div class="accordion">
      <div class="accordion-item" v-for="(item, index) in FAQList" :key="index" >
        <div  v-if="index<5" class="accordion-items">
          <div class="accordion-itemsleft">
            <button
              id="accordion-button-1"
              :aria-expanded="FAQList[index].expanded"
              @click="toggleExpanded(FAQList[index])"
            >
              <span class="accordion-title">{{ FAQList[index].title }}</span
              ><span class="icon" aria-hidden="true"></span>
            </button>
            <div class="accordion-content">
              <p>
                {{ FAQList[index].content }}
              </p>
            </div>
          </div>
          <div class="accordion-itemsright">
            <button
              id="accordion-button-1"
              :aria-expanded="FAQList[index+5].expanded"
              @click="toggleExpanded(FAQList[index+5])"
            >
              <span class="accordion-title">{{ FAQList[index+5].title }}</span
              ><span class="icon" aria-hidden="true"></span>
            </button>
            <div class="accordion-content">
              <p>
                {{ FAQList[index+5].content }}
              </p>
            </div>
          </div>
        </div>
        
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
    FAQList: {},
});

const toggleExpanded = (item) => {
  item.expanded = !item.expanded
}

</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css?family=Hind:300,400&display=swap");
* {
  box-sizing: border-box;
}
*::before,
*::after {
  box-sizing: border-box;
}

body {
  margin: 0;
  padding: 0;
  font-family: "Hind", sans-serif;
  background: #fff;
  color: #4d5974;
  display: flex;
  min-height: 100vh;
}


.accordion .accordion-items {
  display: grid;
  grid-template-columns: 50% 50%;
  border-bottom: 1px solid #e5e5e5;
}

.accordion-itemsright{
  margin-left: 3em;
}
.accordion .accordion-item button[aria-expanded="true"] {
  border-bottom: 1px solid #03b5d2;
}
.accordion button {
  position: relative;
  display: block;
  text-align: left;
  width: 88%;
  padding: 1em 1em 1em 1em;
  color: #7288a2;
  font-size: 1.15rem;
  font-weight: 400;
  border: none;
  background: none;
  outline: none;
}
.accordion button:hover,
.accordion button:focus {
  cursor: pointer;
  color: #03b5d2;
}
.accordion button:hover::after,
.accordion button:focus::after {
  cursor: pointer;
  color: #03b5d2;
  border: 1px solid #03b5d2;
}
.accordion button .accordion-title {
  padding: 1em 1.5em 1em 10px;
}
.accordion button .icon {
  display: inline-block;
  position: absolute;
  top: 18px;
  right: 0;
  width: 22px;
  height: 22px;
  border: 1px solid;
  border-radius: 22px;
}
.accordion button .icon::before {
  display: block;
  position: absolute;
  content: "";
  top: 9px;
  left: 5px;
  width: 10px;
  height: 2px;
  background: currentColor;
}
.accordion button .icon::after {
  display: block;
  position: absolute;
  content: "";
  top: 5px;
  left: 9px;
  width: 2px;
  height: 10px;
  background: currentColor;
}
.accordion button[aria-expanded="true"] {
  color: #03b5d2;
}
.accordion button[aria-expanded="true"] .icon::after {
  width: 0;
}
.accordion button[aria-expanded="true"] + .accordion-content {
  opacity: 1;
  max-height: 9em;
  transition: all 200ms linear;
  will-change: opacity, max-height;
}
.accordion .accordion-content {
  opacity: 0;
  max-height: 0;
  overflow: hidden;
  transition: opacity 200ms linear, max-height 200ms linear;
  will-change: opacity, max-height;
}
.accordion .accordion-content p {
  font-size: 1rem;
  font-weight: 300;
  margin: 2em 10px;
  font-size: 16px;
  line-height: 2em;
  text-align: left;
}
</style>
